<template>
  <div class="grid-view">
    <div class="main-content">
      <div style="width: 100%;" class="section">
        <div style="padding-top: 5px;">
          <el-button type="primary" @click="searchClickHandler">{{ $t('CargoMsg.Cargo_Query') }}</el-button>
          <el-button type="primary" @click="delClickHandler()">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
          <el-checkbox v-model="filter.chkInvoice" style="margin-left: 10px;">{{ $t('CargoMsg.Cargo_ShowInvoiceDetails') }}</el-checkbox>
        </div>

        <el-form label-width="60px" label-position="left" :inline="true" style="padding-top: 10px;">
          <el-form-item :label="$t('CargoMsg.Cargo_InvoiceType')">
            <el-select v-model="filter.invoiceType" style="width:150px;">
              <el-option
                v-for="(item,index) in InvoiceConstant.INVOICE_TYPES_HAS_ALL"
                :key="index"
                :label="$store.getters.language === 'zh' ? item.chineseName : item.englishName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_AcquisitionTime')">
            <el-date-picker v-model="filter.beginDate" :picker-options="pickerOptionsForBeginDate" style="width:130px;" type="date" value-format="yyyy-MM-dd" @change="changeBeginDate" />&nbsp;{{ $t('CargoMsg.Cargo_To') }}
            <el-date-picker v-model="filter.endDate" :picker-options="pickerOptionsForEndDate" style="width:130px;" type="date" value-format="yyyy-MM-dd" @change="changeEndDate" />
          </el-form-item>
        </el-form>
      </div>

      <cargo-up-down-resize
        class="section"
        :up-style="{display: 'flex', flexDirection: 'column', paddingBottom: '5px'}"
        :down-style="{display: 'flex', flexDirection: 'column', paddingTop: '5px'}"
        style="height: 100%"
      >
        <template
          slot="up"
        >
          <div class="section grid-wrapper" style="min-height:350px">
            <cargo-ag-grid
              key="1906065"
              config-module="1906065"
              :grid-params.sync="gridParams"
              :grid-options="gridOptions"
              :column-defs="columnDefs"
              :row-data="rowData"
              style="flex: 1"
              @gridReady="onGridReady"
            />
          </div>
        </template>
        <template
          slot="down"
        >
          <div class="section grid-wrapper" style="min-height:350px">
            <cargo-ag-grid
              v-if="filter.chkInvoice"
              key="1906066"
              config-module="1906066"
              :grid-params.sync="detail.gridParams"
              :grid-options="detail.gridOptions"
              :column-defs="detail.columnDefs"
              :row-data="detail.rowData"
              style="flex: 1"
              @gridReady="onDetailGridReady"
            />
          </div>
        </template>
      </cargo-up-down-resize>
    </div>

  </div>
</template>

<script>
import * as InvoiceConstant from '@/class/cargo/model/parameters/InvoiceConstant'
import cargoUpDownResize from '@/components/Cargo/Common/cargoUpDownResize'
import URL from '@/api/urlTranslator'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getLoading } from '@/utils/utilBaseElement'
import { queryRecipientsInvoiceRecords, delRecipienting } from '@/api/clearing/invoiceNo'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import { recordSelectedStatus } from '@/utils/agGrid'

export default {
  name: 'RecipientsRecords',
  components: { cargoUpDownResize, cargoUserSelect },
  data() {
    return {
      pickerOptionsForBeginDate: { // 设置可选时间范围
        disabledDate: this.disabledBeginDate
      },
      pickerOptionsForEndDate: { // 设置可选时间范围
        disabledDate: this.disabledEndDate
      },
      URL,
      InvoiceConstant,
      selectedItem: null,
      selectTypeNames: TYPE_NAMES,
      filter: {
        invoiceType: null,
        beginDate: '',
        endDate: '',
        chkInvoice: true // 显示发票明细
      },
      filterJson: {},
      rowData: [],
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: false,
        suppressRowSelection: false,
        context: {
          componentParent: this
        },
        onRowClicked: event => { this.changeInvoiceRecords(event.data) }
      },
      gridParams: {},
      gridApi: null,
      columnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_Select'), checkboxSelection: true, width: 70,
          sortable: false, suppressMenu: true, suppressSizeToFit: true,
          resizable: false, headerCheckboxSelection: false
        },
        { headerName: this.$t('CargoMsg.Cargo_InvoiceType'), field: 'invoiceType', colId: 'invoiceType', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.invoiceTypeFunc(params.value)
          } },
        { headerName: this.$t('CargoMsg.Cargo_NumberOfCopies'), field: 'quantity', colId: 'quantity', width: 200 },
        { headerName: this.$t('CargoMsg.Cargo_Acquirer'), field: 'recipienter', colId: 'recipienter', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          } },
        { headerName: this.$t('CargoMsg.Cargo_AcquisitionTime'), field: 'recipientingDate', colId: 'recipientingDate', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } }],
      detail: {
        rowData: [],
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          context: {
            componentParent: this
          }
        },
        gridParams: {},
        gridApi: null,
        columnDefs: [
          { headerName: this.$t('CargoMsg.Cargo_InvoiceType'), field: 'invoiceType', colId: 'invoiceType', width: 200,
            valueFormatter: (params) => {
              return ColumnUtils.invoiceTypeFunc(params.value)
            } },
          { headerName: this.$t('CargoMsg.Cargo_InvoiceNo'), field: 'invoiceNo', colId: 'invoiceNo', width: 200 },
          { headerName: this.$t('CargoMsg.Cargo_InvoiceStatus'), field: 'invoiceState', colId: 'invoiceState', width: 200,
            valueFormatter: (params) => {
              return ColumnUtils.getInvoiceState(params.value)
            } },
          { headerName: this.$t('CargoMsg.Cargo_VoidedBy'), field: 'abandoner', colId: 'abandoner', width: 200,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
            } },
          { headerName: this.$t('CargoMsg.Cargo_VoidTime'), field: 'abandoningDate', colId: 'abandoningDate', width: 200,
            valueFormatter: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            } },

          /* PurchaseInvoiceRecords 子表数据*/
          { headerName: this.$t('CargoMsg.Cargo_PurchasedBy'), field: 'purchaser', colId: 'purchaser', width: 200,
            valueFormatter: (params) => {
              const purchaseInvoiceRecords = params.data.purchaseInvoiceRecords || {}
              const value = purchaseInvoiceRecords.purchaser || 0
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', value, 'chineseName')
            } },
          { headerName: this.$t('CargoMsg.Cargo_TimeOfPurchase'), field: 'purchasingDate', colId: 'purchasingDate', width: 200,
            valueFormatter: (params) => {
              const purchaseInvoiceRecords = params.data.purchaseInvoiceRecords || {}
              const value = purchaseInvoiceRecords.purchasingDate || ''
              return ColumnUtils.dateLabelFunc(value)
            } },

          { headerName: this.$t('CargoMsg.Cargo_User'), field: 'user', colId: 'user', width: 200,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
            } },
          { headerName: this.$t('CargoMsg.Cargo_TimeOfUse'), field: 'usingDate', colId: 'usingDate', width: 200,
            valueFormatter: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            } }
        ]
      }
    }
  },
  created() {
  },
  methods: {
    // 查询
    searchClickHandler() {
      const proxy = {}
      if (this.filter.invoiceType != null) {
        proxy['invoiceType'] = this.filter.invoiceType
      }
      if (this.filter.beginDate) {
        proxy['recipientingDateMin'] = this.filter.beginDate
      }
      if (this.filter.endDate) {
        proxy['recipientingDateMax'] = this.filter.endDate
      }
      proxy['branchId'] = this.$store.getters.currentOfficeId
      this.loading = getLoading()
      console.log('proxy===========', proxy)
      const selectedStatus = recordSelectedStatus(this.gridApi, 'uuid')
      queryRecipientsInvoiceRecords({ conMap: proxy }).then(res => {
        this.rowData = res.data
        this.detail.rowData = []
        this.gridApi.clearFocusedCell()
        selectedStatus.revert()
      }).finally(() => {
        this.loading.close()
      })
    },
    // 删除
    delClickHandler() {
      const selectedItems = this.gridApi.getSelectedRows()
      if (!selectedItems || selectedItems.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SelectAcquiredRecord'))
        return
      }
      this.$confirm(this.$t('CargoMsg.Cargo_SureToDelete'), this.$t('CargoMsg.Cargo_Tips'), {
        confirmButtonText: this.$t('common.btn.yes'),
        cancelButtonText: this.$t('common.btn.no'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => {
        const keys = Array.from(selectedItems, p => p.uuid)
        this.loading = getLoading()
        delRecipienting({ keys: keys }).then(res => {
          this.$message.success(this.$t('CargoMsg.Cargo_DeletedSuccessfully'))
          this.searchClickHandler()
        }).finally(() => {
          this.loading.close()
        })
      })
    },
    // 切换发票带出发票明细
    changeInvoiceRecords(data) {
      if (!data || !data.uuid) return
      this.selectedItem = data
      if (this.selectedItem) {
        this.detail.rowData = this.selectedItem.invoiceNo || []
      }
    },
    // 各列表 API 初始化
    onGridReady(params) {
      this.gridApi = params.api
    },
    onDetailGridReady(params) {
      this.detail.gridApi = params.api
    },
    changeBeginDate() {
      if (!this.filter.beginDate) this.filter.endDate = ''
      if (this.filter.beginDate && !this.filter.endDate) this.filter.endDate = new Date()
    },
    changeEndDate() {
      if (!this.filter.endDate) this.filter.beginDate = ''
      if (this.filter.endDate && !this.filter.beginDate) {
        const curDate = new Date()
        this.filter.beginDate = new Date(curDate)
        this.filter.beginDate.setDate(curDate.getDate() - 7)
      }
    },
    // 设置不可选日期范围
    disabledBeginDate(time) {
      if (!this.filter.endDate) {
        // 设置可选择的日期为今天之后的6天内
        const curDate = (new Date()).getTime()
        return time.getTime() > curDate
      }
      const endDate = (new Date(this.filter.endDate)).getTime()
      return time.getTime() > endDate
    },
    // 设置不可选日期范围
    disabledEndDate(time) {
      if (this.filter.beginDate) {
        const endDate = (new Date(this.filter.beginDate)).getTime()
        const dateRegion = endDate - 1 * 24 * 3600 * 1000
        return time.getTime() < dateRegion
      }
    }
  }
}
</script>
